import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"18px"} }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"18px"} }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "授权给我的店", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "活动服务费您与对方协商，建议您收取198元。"),
  /*#__PURE__*/_createElementVNode("li", null, "活动成交款进您的微信支付商户，您与对方直接结算。"),
  /*#__PURE__*/_createElementVNode("li", null, "若有业务问题，请点击右下角微信图标，咨询助教老师。")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"18px"} }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"18px"} }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("blockquote", null, "【店家活动宝】xxx申请代你的店做拓客活动，点击前往给他授权 http://3tfx.cn/xxx", -1)

import {onMounted, reactive} from "vue";
import {editor} from "@/app/editor";
import {IconFont, req} from "@/lib/util";
import {ShopSectionV1} from "@/app/editor/modules/shop/v1/index";
import BlockView from "@/components/block/BlockView.vue";
import BlockTitleView from "@/components/block/BlockTitleView.vue";
import dayjs from "dayjs";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShopSetup',
  props: {
    index: {}
  },
  setup(__props: any) {

const props = __props
const shop = editor.activity?.modules[props.index] as ShopSectionV1

const info = reactive({
  tooltip: {show: false},
  apply: {loading: false, phone_number: ''},
  invite: {show: false}
})

onMounted(async () => {
  if (!editor.activity?.isEdit()) {
    const ob = new IntersectionObserver(es => {
      es.forEach(e => {
        info.tooltip.show = !!e.intersectionRatio
      })
    })
    ob.observe(document.getElementsByClassName('tab-tip')[0])
  } else shop.syncData()
})

const onApply = () => {
  if (info.apply.loading) return
  info.apply.loading = true
  req({
    url: 'activity/apply/authorization',
    method: 'post',
    data: {apply_phone_number: info.apply.phone_number},
    success: () => {
      let has = false
      editor.activity?.data.apply_authorizations.forEach((a, k) => {
        if (a.apply_phone_number == info.apply.phone_number) {
          has = true
          editor.activity!.data.apply_authorizations[k].expire_days = 7
        }
      })
      if (!has) editor.activity?.data.apply_authorizations.push({
        apply_id: Math.random().toString(36).slice(2),
        apply_phone_number: info.apply.phone_number,
        accept_at: null,
        expire_days: 7,
        auth_count: 0
      })
      info.invite.show = true
      info.apply.phone_number = ''
    }, complete: () => info.apply.loading = false
  })
};


return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_table_summary_cell = _resolveComponent("a-table-summary-cell")!
  const _component_a_table_summary_row = _resolveComponent("a-table-summary-row")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_unref(shop))
    ? (_openBlock(), _createBlock(BlockView, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(BlockTitleView, null, {
            default: _withCtx(() => [
              _createVNode(_unref(IconFont), {
                type: `icon-${_unref(shop).icon}`,
                style: {"padding-right":"8px"}
              }, null, 8, ["type"]),
              _createTextVNode(" " + _toDisplayString(_unref(shop).title), 1)
            ]),
            _: 1
          }),
          (_unref(editor).activity?.isEdit())
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_a_alert, {
                  type: "info",
                  "show-icon": "",
                  message: "若需要更改活动门店请重新创建活动"
                }),
                _hoisted_2,
                _createVNode(_component_a_table, {
                  "data-source": [_unref(shop).config.shop],
                  columns: [{title:'店名',dataIndex:'shop_name'},{title:'预约电话',dataIndex:'tel'},{title:'地址',dataIndex: 'addr'}]
                }, null, 8, ["data-source"])
              ]))
            : (_openBlock(), _createBlock(_component_a_tabs, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "1",
                    tab: "我的店"
                  }, {
                    default: _withCtx(() => [
                      (_unref(editor).activity!.data.shops.filter(s => !(s.tel.length>5 && s.shop_name.length>2 && s.icon.length>22 && s.coordinate.length==2 && s.coordinate[0]>0)).length>0)
                        ? (_openBlock(), _createBlock(_component_a_alert, {
                            key: 0,
                            type: "info",
                            "show-icon": "",
                            message: "添加或完善门店基础信息要前往管店宝App中，如有疑问请点击右下角微信图标，联系助教老师"
                          }))
                        : _createCommentVNode("", true),
                      _hoisted_3,
                      _createVNode(_component_a_table, {
                        "data-source": _unref(editor).activity?.data.shops ?? [],
                        columns: [{title: '选择'},{title:'店名',dataIndex:'shop_name'},{title:'预约电话',dataIndex:'tel'},{title:'地址',dataIndex: 'addr'}]
                      }, {
                        bodyCell: _withCtx(({ column, record }) => [
                          (column.title === '选择')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (record.tel.length>5 && record.shop_name.length>1 && record.icon.length>22 && record.coordinate.length==2 && record.coordinate[0]>0)
                                  ? (_openBlock(), _createBlock(_component_a_radio, {
                                      key: 0,
                                      style: {"zoom":"1.5"},
                                      checked: record.sid==_unref(shop).config.shop.sid,
                                      onClick: ($event: any) => (_unref(shop).config.shop=record)
                                    }, null, 8, ["checked", "onClick"]))
                                  : (_openBlock(), _createBlock(_component_a_tooltip, {
                                      key: 1,
                                      title: "基本信息不完整"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_radio, {
                                          style: {"zoom":"1.5"},
                                          disabled: ""
                                        })
                                      ]),
                                      _: 1
                                    }))
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, { key: "2" }, {
                    tab: _withCtx(() => [
                      _createVNode(_component_a_tooltip, {
                        open: info.tooltip.show,
                        "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((info.tooltip.show) = $event)),
                        class: "tab-tip",
                        placement: "top",
                        color: "blue",
                        "get-popup-container": e => e.parentElement.parentElement.parentElement.parentElement.parentElement
                      }, {
                        title: _withCtx(() => [
                          _createTextVNode("这里能代别人的店做活动")
                        ]),
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }, 8, ["open", "get-popup-container"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_alert, {
                        type: "info",
                        "show-icon": "",
                        message: "温馨提示"
                      }, {
                        description: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _hoisted_6,
                      _createVNode(_component_a_table, {
                        "data-source": _unref(editor).activity?.data.auth_shops ?? [],
                        columns: [{title:'已授权',children:[{title: '选择'},{title:'店名',dataIndex:'shop_name'},{title:'预约电话',dataIndex:'tel'},{title:'地址',dataIndex: 'addr'},{title: '授权有效期',dataIndex: 'expire_days'}]}]
                      }, {
                        bodyCell: _withCtx(({ column, record }) => [
                          (column.title==='授权有效期')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(record.expire_days) + "天 ", 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (column.title === '选择')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (record.tel.length>5 && record.shop_name.length>1 && record.icon.length>10 && record.coordinate.length==2 && record.coordinate[0]>0)
                                  ? (_openBlock(), _createBlock(_component_a_radio, {
                                      key: 0,
                                      checked: record.sid==_unref(shop).config.shop.sid,
                                      onClick: ($event: any) => (_unref(shop).config.shop=record)
                                    }, null, 8, ["checked", "onClick"]))
                                  : (_openBlock(), _createBlock(_component_a_tooltip, {
                                      key: 1,
                                      title: "基本信息不完整"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_radio, { disabled: "" })
                                      ]),
                                      _: 1
                                    }))
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["data-source"]),
                      _hoisted_7,
                      _createVNode(_component_a_table, {
                        "data-source": _unref(editor).activity?.data.apply_authorizations ?? [],
                        columns: [{title:'待授权',children:[{title:'手机号',dataIndex:'apply_phone_number'},{title:'浏览时间',dataIndex:'accept_at'},{title: '授权有效期',dataIndex: 'expire_days'},{title: '当前有效授权门店数',dataIndex: 'auth_count'}]}]
                      }, {
                        bodyCell: _withCtx(({ column, record }) => [
                          (column.title==='授权有效期')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(record.expire_days) + "天 ", 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (column.title === '浏览时间')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(record.accept_at ? _unref(dayjs)(record.accept_at).format('YYYY-MM-DD HH:mm:ss') : '暂未打开'), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        summary: _withCtx(() => [
                          _createVNode(_component_a_table_summary_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_table_summary_cell, { "col-span": 4 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_flex, { gap: "middle" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input_number, {
                                        min: 11000000000,
                                        max: 19999999999,
                                        "addon-before": "手机号",
                                        placeholder: "请输入11位手机号",
                                        disabled: info.apply.loading,
                                        value: info.apply.phone_number,
                                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((info.apply.phone_number) = $event)),
                                        "max-length": 11
                                      }, null, 8, ["disabled", "value"]),
                                      _createVNode(_component_a_button, {
                                        type: "primary",
                                        loading: info.apply.loading,
                                        onClick: onApply
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(info.apply.loading ? '发送中' : '发起邀请'), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["loading"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data-source"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })),
          _createVNode(_component_a_modal, {
            open: info.invite.show,
            "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((info.invite.show) = $event)),
            title: "邀请短信已发送"
          }, {
            footer: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (info.invite.show=false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确定")
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_typography_paragraph, null, {
                default: _withCtx(() => [
                  _createTextVNode(" 短信内容： "),
                  _hoisted_8,
                  _createTextVNode(" 对方打开链接后前往微信小程序，完成授权后。刷新此页，就能在“已授权”的门店列表中看到。 ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["open"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})